import Component from '@galactic-advisors/component-loader';
import axios from 'axios';
import { Toast, ToastStatusTypes } from '../../../../../../ts/toast.ts';

const DEFAULTS = {
  addImplementationButtonElement: '[data-add-implementation-button]',
  implementationRowElement: '[data-implementation-row]',
  modalCloseButtonElement: '[data-modal-close-button]',
  modalFinishButtonElement: '[data-modal-finish-button]',
  filterImplementationsInputElement: '[data-filter-implementations-input]',
  implementationNameElement: '[data-implementation-name]',
  implementationDescElement: '[data-implementation-desc]',
};

export default class AddImplementationModal extends Component {
  static selector = '[data-comp-add-implementation-modal]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.addImplementationButtons = [
      ...this.$container.querySelectorAll(
        this.$options.addImplementationButtonElement
      ),
    ];

    this.modalCloseButton = this.$container.querySelector(
      this.$options.modalCloseButtonElement
    );

    this.modalFinishButton = this.$container.querySelector(
      this.$options.modalFinishButtonElement
    );

    this.filterImplementationsInput = this.$container.querySelector(
      this.$options.filterImplementationsInputElement
    );

    this.implementations = [
      ...this.$container.querySelectorAll(
        this.$options.implementationRowElement
      ),
    ];

    this.toast = Toast.instance;

    this.initListeners();
  }

  async addImplementation(implementationId, event, route) {
    return axios
      .post(route, {
        implementation_id: implementationId,
      })
      .then((response) => {
        this.toast.show(ToastStatusTypes.SUCCESS, response.data.message);

        // Remove the newly added implementation from the list
        const implementationRow = event.target.closest(
          this.$options.implementationRowElement
        );
        implementationRow.style.display = 'none';
      })
      .catch((error) => {
        this.toast.show(ToastStatusTypes.DANGER, error.response.data.message);
      });
  }

  initListeners() {
    this.addImplementationButtons.forEach((button) => {
      button.addEventListener('click', async (event) => {
        event.preventDefault();

        const route = button.dataset.modalRoute;

        const { implementationId } = event.target.dataset;

        return this.addImplementation(implementationId, event, route);
      });
    });

    this.modalFinishButton.addEventListener('click', (event) => {
      event.preventDefault();

      window.location.reload();
    });

    this.modalCloseButton.addEventListener('click', (event) => {
      event.preventDefault();
    });

    this.filterImplementationsInput.addEventListener('keyup', (event) => {
      this.implementations.forEach((implementation) => {
        const implementationName = implementation.querySelector(
          this.$options.implementationNameElement
        );
        const implementationDesc = implementation.querySelector(
          this.$options.implementationDescElement
        );

        if (
          implementationName.textContent
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          implementationDesc.textContent
            .toLowerCase()
            .includes(event.target.value.toLowerCase())
        ) {
          implementation.style.display = 'flex';
        } else {
          implementation.style.display = 'none';
        }
      });
    });
  }
}
